import money from '@images/money.webp';
import moneyRetina from '@images/money@2x.webp';

export const mapping = {
  money: {
    '1x': money,
    '2x': moneyRetina,
  },
};